import React, { Component, Fragment, createRef } from 'react';
import CollapseMenu from '../../../../config/atoms/CollapseMenu';
import MenuDetail from '../MenuDetail';
import PrintKHS from './printKHS/PrintKHS';
import ProdiSwitch from './printKHS/ProdiSwitch';
import { DateIndo } from '../../../../utils/helpers';
import swal from 'sweetalert';
import { dataKHS } from '../../../../dummy-data/krs-khs';
import { dataMahasiswa } from '../../../../dummy-data/mahasiswa';

var nowDate = new Date();
var tanggal = DateIndo(nowDate);

class Khs extends Component {
    constructor() {
        super()
        this.state = {
            user: [],
            listSemester: [],
            listNilai: [],
            listDetailNilai: [],
            detailNilai: [],
            formNilai: [],
            nilai: [],
            semester: '',
            bahasa: 'indonesia',
            ttd1: "",
            ttd2: "",
            isLoading: false,
            nilaifinal: "",
            idkrs: "",
            // params
            idVal: '',
            nimVal: '',
        };
        this.closeModal = createRef();
    }

    getAllData = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);
        const khsData = dataKHS.filter(k => k.nim === nim);

        // Get unique semesters
        const semesters = [...new Set(khsData.map(k => k.semester_ke))].sort((a, b) => a - b);

        this.setState({
            user: {
                angkatan: mhs ? mhs.angkatan : '2020',
                jurusan: mhs ? mhs.prodi : 'Teknik Informatika',
                nama: mhs ? mhs.nama : 'Mahasiswa Demo',
                nim: nim,
                kurikulum: '2020',
                kaprodi: 'Dr. Ahmad Susanto, M.Kom.',
                dosenwali: 'Joko Santoso, S.Kom., M.T.',
                nidn_kaprodi: '0712098901',
                nidn: '0715097802'
            },
            listSemester: semesters.map(s => ({ semester: s })),
            ttd1: 'Dr. Ahmad Susanto, M.Kom.',
            ttd2: 'Joko Santoso, S.Kom., M.T.'
        });
    }

    execNilai = (type, bahasa) => {
        const nim = this.state.nimVal;
        const semesterKe = parseInt(this.state.semester);

        this.setState({ isLoading: true });

        // Filter KHS data by semester
        const khsFiltered = dataKHS.filter(k => k.nim === nim && k.semester_ke === semesterKe);

        // Map to expected format
        const mappedData = khsFiltered.map((k, idx) => ({
            idkrs: k.khs_id,
            kodemk: k.kode_mk,
            matakuliah: k.nama_mk,
            matkul_inggris: k.nama_mk,
            sks: k.sks,
            nilai: k.nilai,
            grade: k.grade,
            sksn: (k.sks * k.bobot).toFixed(2),
            nilaifinal: k.nilai,
            dosen: 'Dosen Demo',
            detail: [
                { jenis: 'Tugas', prosentase: '20%', nilai: Math.round(k.nilai * 0.95), grade: k.grade },
                { jenis: 'UTS', prosentase: '30%', nilai: Math.round(k.nilai * 0.98), grade: k.grade },
                { jenis: 'UAS', prosentase: '50%', nilai: k.nilai, grade: k.grade }
            ]
        }));

        const totalSKS = mappedData.reduce((sum, m) => sum + m.sks, 0);
        const totalSKSN = mappedData.reduce((sum, m) => sum + parseFloat(m.sksn), 0);
        const ips = totalSKS > 0 ? (totalSKSN / totalSKS).toFixed(2) : 0;

        // Calculate IPK (cumulative)
        const allKHS = dataKHS.filter(k => k.nim === nim && k.semester_ke <= semesterKe);
        const totalSKSAll = allKHS.reduce((sum, k) => sum + k.sks, 0);
        const totalBobotAll = allKHS.reduce((sum, k) => sum + (k.sks * k.bobot), 0);
        const ipk = totalSKSAll > 0 ? (totalBobotAll / totalSKSAll).toFixed(2) : 0;

        const formNilai = mappedData.map(item => ({
            idkrs: item.idkrs,
            nilaifinal: item.nilaifinal
        }));

        setTimeout(() => {
            this.setState({
                listNilai: mappedData,
                formNilai: formNilai,
                nilai: {
                    data: mappedData,
                    totalsks: totalSKS,
                    totalsksn: totalSKSN.toFixed(2),
                    ips: ips,
                    ipk: ipk,
                    batas_sks: parseFloat(ipk) >= 3.0 ? 24 : 21,
                    ta: '2024/2025'
                },
                isLoading: false
            }, () => {
                if (type === "print") {
                    PrintKHS(bahasa, this.state.user.jurusan);
                }
            });
        }, 300);
    }

    inputSemester = (e) => {
        this.setState({ semester: e.target.value }, () => { this.execNilai("no-print", "indonesia") })
    }

    print = (bahasa) => {
        this.setState({ bahasa }, () => { this.execNilai("print", this.state.bahasa) })
    }

    detailNilai = (data) => {
        this.setState({ listDetailNilai: data.detail, detailNilai: data })
    }

    handleInput = (e, indexOf) => {
        this.setState((prevState) => {
            const updatedListNilai = [...prevState.formNilai];
            updatedListNilai[indexOf]['nilaifinal'] = e.target.value;
            return { formNilai: updatedListNilai };
        });
    }

    editNilaiKHS = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.closeModal.current.click();
            swal({
                icon: 'success',
                title: 'Demo Mode',
                text: 'Nilai berhasil diupdate (simulasi)',
                timer: 1500,
                buttons: false
            });
            this.setState({ isLoading: false });
        }, 500);
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData()
        })
    }

    componentDidMount = () => {
        document.getElementById("khsMenu").classList.add("active");
        CollapseMenu();
        this.setParams()
    };

    render() {
        var i;
        var output = "";
        for (i = 5; i < this.state.ttd1.length; i++) { output += "_" }
        var i2;
        let output2 = "";
        for (i2 = 5; i2 < this.state.ttd2.length; i2++) { output2 += "_" }

        const getMutualdata = (idkrs, attr) => {
            const resData = this.state.listNilai.find((x) => x.idkrs == idkrs)
            return resData[attr]
        }

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Detail KHS
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="smoothMain">

                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>

                    <div className="col-xl-9" id="kontenKiri">
                        <div className="card card-custom">
                            <div className="card-body">
                                <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                    Kartu Hasil Studi
                                </p>
                                <div className="table-responsive pl-2 pr-2">
                                    <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                        <thead></thead>
                                        <tbody>
                                            <tr>
                                                <td>NIM</td>
                                                <td> : </td>
                                                <td>{this.state.user.nim}</td>

                                                <td>Angkatan</td>
                                                <td> : </td>
                                                <td>{this.state.user.angkatan}</td>
                                            </tr>
                                            <tr>
                                                <td>Nama</td>
                                                <td> : </td>
                                                <td>{this.state.user.nama}</td>

                                                <td>Semester</td>
                                                <td> : </td>
                                                <td>
                                                    <select className="form-control" name="semester" onChange={this.inputSemester} value={this.state.semester}>
                                                        <option value="">- Pilih Semester -</option>
                                                        {this.state.listSemester.map((v, index) => {
                                                            return (
                                                                <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                            )
                                                        })
                                                        }
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br />
                                <br />
                                <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                    Laporan KHS & Detail Nilai :
                                </p>
                                {
                                    this.state.isLoading ?
                                        <div id="loaderMhs">
                                            <div className="loader-1 colorful mt-5 mb-2">
                                                <div className="dot" />
                                                <div className="dot" />
                                                <div className="dot" />
                                            </div>
                                            <p align="center" className="mb-5">loading data...</p>
                                        </div>
                                        :
                                        <>
                                            <div className="table-responsive">
                                                {
                                                    this.state.listNilai.length == 0 ? null :
                                                        <div className="dropdown mb-1" style={{ float: 'right' }}>
                                                            {
                                                                this.props.grub_id == 48 ? null :
                                                                    <>
                                                                        <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            <i className="fa fa-print"></i>&nbsp;&nbsp;Aksi
                                                                        </button>
                                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                            <a data-toggle="modal" href="#edit-nilai" className="dropdown-item" style={{ cursor: 'pointer' }}>
                                                                                <i className="fa fa-pencil"></i>&nbsp;&nbsp;edit nilai
                                                                            </a>
                                                                        </div>
                                                                    </>
                                                            }
                                                        </div>
                                                }
                                                <table width="100%" align="center" className="display expandable-table table-bordered table-radius">
                                                    <thead>
                                                        <tr align="center">
                                                            <th scope="row" style={{ borderRadius: '0px' }}>No</th>
                                                            <th colSpan={2}>Kode Mata Kuliah</th>
                                                            <th colSpan={2}>Nama Mata Kuliah</th>
                                                            <th>SKS</th>
                                                            <th>Nilai</th>
                                                            <th>Huruf</th>
                                                            <th>SKS x N</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.listNilai.length == 0 ?
                                                            <tr><td className='text-center' colSpan={9}>- Tidak Ada Data -</td></tr>
                                                            :
                                                            <Fragment>
                                                                {
                                                                    this.state.listNilai.map((list, i) => {
                                                                        return (
                                                                            <tr height={10} key={i}>
                                                                                <td align="center" scope="row">{i + 1}</td>
                                                                                <td colSpan={2} align="center">
                                                                                    <button type="button"
                                                                                        title="detail nilai mk"
                                                                                        className="btn btn-primary btn-sm btn-nilai" data-toggle="modal" data-target="#nilai"
                                                                                        onClick={() => this.detailNilai(list)}>
                                                                                        {list.kodemk}
                                                                                    </button>
                                                                                </td>
                                                                                <td>{list.kodemk}</td>
                                                                                <td align="center">{list.matakuliah}</td>
                                                                                <td align="center">{list.sks}</td>
                                                                                <td align="center">{list.nilai}</td>
                                                                                <td align="center">{list.grade}</td>
                                                                                <td align="center">{list.sksn}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </Fragment>
                                                        }
                                                    </tbody>
                                                    <tfoot>
                                                        <tr className="customPadding customTable">
                                                            <td colSpan={5}>Total</td>
                                                            <td align="center">{this.state.nilai.totalsks ?? "-"}</td>
                                                            <td align="center">-</td>
                                                            <td align="center">-</td>
                                                            <td align="center">{this.state.nilai.totalsksn ?? "-"}</td>
                                                        </tr>
                                                        <tr className="customPadding">
                                                            <td colSpan={8}>IP Semester</td>
                                                            <td align="center">{this.state.nilai.ips ?? "-"}</td>
                                                        </tr>
                                                        <tr className="customPadding customTable">
                                                            <td colSpan={8} className="no-border-right">IP Kumulatif</td>
                                                            <td align="center" className="no-border-left">{this.state.nilai.ipk ?? "-"}</td>
                                                        </tr>
                                                        <tr className="customPadding customTable">
                                                            <td colSpan={8}>Beban Maksimal SKS Semester Depan</td>
                                                            <td align="center">{this.state.nilai.batas_sks ?? "-"}</td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                            <br />
                                            {
                                                this.state.listNilai.length == 0 ? null :
                                                    <div className="dropdown mb-1" style={{ float: 'right' }}>
                                                        <button className="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                            <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak KHS .PDF
                                                        </button>
                                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => this.print('indonesia')}><i className="fa fa-print"></i>&nbsp;&nbsp;Bahasa Indonesia</a>
                                                            <a className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => this.print('english')}><i className="fa fa-print"></i>&nbsp;&nbsp;Bahasa Inggris</a>
                                                        </div>
                                                    </div>
                                            }
                                        </>
                                }
                            </div>
                        </div>
                    </div>

                    {/* Modal detail nilai khs */}
                    <div className="modal fade" id="nilai" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Detail Nilai <span style={{ color: '#8cb8ff' }}>[{this.state.detailNilai.kodemk}]</span> {this.state.detailNilai.matakuliah}
                                        <br />
                                        <br />
                                        <span style={{
                                            fontSize: '14px', backgroundColor: '#f29327', borderRadius: '30px',
                                            padding: '5px 15px 5px 15px', color: 'white'
                                        }}>{this.state.detailNilai.dosen}</span>
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" className="close-btn">×</span></button>
                                </div>
                                <div className="pl-3 pr-3 pt-3 pb-5">
                                    <div className="table-responsive">
                                        <table className="display expandable-table table-striped tableBord" style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Jenis Penilaian</th>
                                                    <th>Persentase</th>
                                                    <th>Angka</th>
                                                    <th>Huruf</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.listDetailNilai.map((list, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{list.jenis}</td>
                                                                <td>{list.prosentase}</td>
                                                                <td>{list.nilai}</td>
                                                                <td>{list.grade}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal detail nilai khs */}

                    {/* Modal edit nilai khs */}
                    <div className="modal fade bd-example-modal-lg" id="edit-nilai" tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                        Edit Nilai KHS
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" ref={this.closeModal}>
                                        <span aria-hidden="true" className="close-btn">×</span>
                                    </button>
                                </div>
                                <div className="pl-3 pr-3 pt-3 pb-2">
                                    <div className="table-responsive">
                                        <table className="display expandable-table table-striped tableBord" style={{ width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Kode MK</th>
                                                    <th>Mata Kuliah</th>
                                                    <th>Angka</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.formNilai.map((list, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>{getMutualdata(list.idkrs, "kodemk")}</td>
                                                                <td>{getMutualdata(list.idkrs, "matakuliah")}</td>
                                                                <td>
                                                                    <input type="number"
                                                                        name={list.idkrs}
                                                                        onChange={(e) => this.handleInput(e, i)}
                                                                        className="form-control"
                                                                        value={list.nilaifinal} />
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <p align="right">
                                        <button
                                            className="btn btn-success btn-md"
                                            style={{ borderRadius: '5px', marginTop: '28.5px' }}
                                            type="submit"
                                            onClick={this.editNilaiKHS}
                                            disabled={this.state.isLoading}
                                        >
                                            {this.state.isLoading ? "Loading..." : "Simpan"}
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal edit nilai khs*/}

                </div>
                <div style={{ display: 'none' }}>
                    <div>
                        <table id="headerTabel">
                            <thead></thead>
                            <tbody className='times'>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Nama' : 'Name'}</td>
                                    <td> : </td>
                                    <td>{this.state.user.nama}</td>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Tahun Angkatan' : 'Year'}</td>
                                    <td> : </td>
                                    <td>{this.state.user.angkatan}</td>
                                </tr>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'NIM' : 'Student Number'}</td>
                                    <td> : </td>
                                    <td>{this.state.user.nim}</td>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Tahun Akademik' : 'Academic Year'}</td>
                                    <td> : </td>
                                    <td>{this.state.nilai.ta}</td>
                                </tr>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Program Studi' : 'Major'}</td>
                                    <td> : </td>
                                    <td>{this.state.bahasa == "indonesia" ? this.state.user.jurusan : ProdiSwitch(this.state.user.jurusan)}</td>
                                    <td>Semester</td>
                                    <td> : </td>
                                    <td>{this.state.semester}</td>
                                </tr>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Konsentrasi' : 'Concentration'}</td>
                                    <td> : </td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="tabelMK" border="1">
                            <thead>
                                <tr align="center">
                                    <th scope="row">No</th>
                                    <th colSpan={2}>{this.state.bahasa == 'indonesia' ? 'Kode Mata Kuliah' : 'Course Code'}</th>
                                    <th colSpan={2}>{this.state.bahasa == 'indonesia' ? 'Nama Mata Kuliah' : 'Course Name'}</th>
                                    <th>{this.state.bahasa == 'indonesia' ? 'SKS' : 'Credit'}</th>
                                    <th>{this.state.bahasa == 'indonesia' ? 'Nilai' : 'Score'}</th>
                                    <th>{this.state.bahasa == 'indonesia' ? 'Huruf' : 'Grade'}</th>
                                    <th>{this.state.bahasa == 'indonesia' ? 'SKS x N' : 'Credit x S'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.listNilai.map((list, i) => {
                                        return (
                                            <tr key={i}>
                                                <td scope="row">{i + 1}</td>
                                                <td colSpan={2}>{list.kodemk}</td>
                                                <td colSpan={2}>{this.state.bahasa == "indonesia" ? list.matakuliah : list.matkul_inggris}</td>
                                                <td>{list.sks}</td>
                                                <td>{list.nilai}</td>
                                                <td>{list.grade}</td>
                                                <td>{list.sksn}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td colSpan={5}>&nbsp;<b>Total</b></td>
                                    <td>{this.state.nilai.totalsks ?? "-"}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{this.state.nilai.totalsksn ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>{this.state.bahasa == 'indonesia' ? 'IP Semester' : 'GP Semester'}</td>
                                    <td>{this.state.nilai.ips ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}> {this.state.bahasa == 'indonesia' ? 'IP Kumulatif' : 'Grade Point Average'}</td>
                                    <td>{this.state.nilai.ipk ?? "-"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>{this.state.bahasa == 'indonesia' ? 'Beban Maksimal SKS Semester Depan' : 'Maximum Load of Credits for Next Semester'}</td>
                                    <td align="center">{this.state.nilai.batas_sks ?? "-"}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="ttd">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>Malang, {tanggal}</td>
                                </tr>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Mengetahui,' : 'Regard,'}</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Kepala Program Studi,' : 'Head of Study Program,'}</td>
                                    <td>{this.state.bahasa == 'indonesia' ? 'Dosen Wali,' : 'Lecturer,'}</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        {this.state.user.kaprodi}
                                    </td>
                                    <td>
                                        {this.state.user.dosenwali}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        {output}
                                    </td>
                                    <td>
                                        {output2}
                                    </td>
                                </tr>
                                <tr>
                                    <td>NIDN. {this.state.user.nidn_kaprodi}</td>
                                    <td>NIDN. {this.state.user.nidn}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Khs;